import React, { useRef } from 'react'
import throttle from 'lodash.throttle'

export const useInfiniteScroll = (
  loading: boolean,
  onNextPageByScroll: () => void,
  options: {
    vertical?: boolean
    reverse?: boolean
  } = { vertical: true, reverse: false },
): ((e: React.UIEvent<HTMLElement>) => void) => {
  const { vertical = true, reverse = false } = options
  const lastScrollPos = useRef(0)
  const invoked = useRef(false)
  const scrollContainerRef = useRef<HTMLElement | null>(null)
  const scrollSizeBeforeLoad = useRef(0)

  return throttle(
    async (e: React.UIEvent<HTMLElement>) => {
      const target: HTMLElement = e.target as HTMLElement
      scrollContainerRef.current = target

      const currentScrollPos = vertical ? target.scrollTop : target.scrollLeft
      const scrollSize = vertical ? target.scrollHeight : target.scrollWidth
      const clientSize = vertical ? target.clientHeight : target.clientWidth

      const isScrollingToEnd = reverse
        ? currentScrollPos < lastScrollPos.current || currentScrollPos === 0
        : currentScrollPos > lastScrollPos.current

      lastScrollPos.current = currentScrollPos

      if (!isScrollingToEnd) {
        return
      }

      const koef = 0.5
      const threshold = (scrollSize - clientSize) * koef

      const isScrolledToThreshold = reverse
        ? currentScrollPos <= threshold
        : currentScrollPos >= threshold

      const shouldLoadMoreData = isScrolledToThreshold && !loading && !invoked.current

      if (shouldLoadMoreData) {
        invoked.current = true
        scrollSizeBeforeLoad.current = scrollSize

        await onNextPageByScroll?.()

        // Восстанавливаем позицию скролла после загрузки
        const shouldRestoreScroll = scrollContainerRef.current && !vertical && reverse

        if (shouldRestoreScroll) {
          const newScrollSize = vertical
            ? scrollContainerRef.current.scrollHeight
            : scrollContainerRef.current.scrollWidth

          const scrollDelta = newScrollSize - scrollSizeBeforeLoad.current
          scrollContainerRef.current.scrollLeft += scrollDelta
        }

        invoked.current = false
      }
    },
    1000,
    {
      leading: false,
      trailing: true,
    },
  )
}
